import { Country } from '@tiendanube/common/src/enums';
import ShowByCountry from 'App/components/ShowByCountry';
import { getD2cEventStatus } from 'App/components/Topbar/utils';
import { trackingMenuD2cEvent } from 'App/tracking';
import { useResponsive } from 'commons/components';
import { useDismissibleComponent } from 'commons/hooks';
import { openWindow } from 'commons/utils/window';
import D2CBannerDesktop from './components/D2CBannerDesktop';
import D2CBannerMobile from './components/D2CBannerMobile';

const eventUrl =
  'https://www.sympla.com.br/evento/d2c-summit/2918712?d=20-CLIENTE&utm_source=admin&utm_medium=banner-grande-admin&utm_campaign=abertura-vendas-2304';

function D2CBanner() {
  const { isMobile: isMobileResponsive } = useResponsive();
  const { enable } = getD2cEventStatus();
  const { shouldShow, dismiss } = useDismissibleComponent(
    'd2c-banner-dismiss',
    30,
  );

  const handelClick = () => {
    trackingMenuD2cEvent('banner_click');
    openWindow(eventUrl, true);
  };

  const handelClose = () => {
    trackingMenuD2cEvent('banner_close');
    dismiss();
  };

  if (!enable || !shouldShow) {
    return null;
  }

  return (
    <ShowByCountry allowedCountries={[Country.BR]}>
      {isMobileResponsive ? (
        <D2CBannerMobile onClose={handelClose} onClick={handelClick} />
      ) : (
        <D2CBannerDesktop onClose={handelClose} onClick={handelClick} />
      )}
    </ShowByCountry>
  );
}

export default D2CBanner;
